import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

interface BlogListingItemBlockProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  image?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const BlogListingItemBlock = forwardRef<
  HTMLDivElement,
  BlogListingItemBlockProps
>(({ image, content, styles = {}, className, ...rest }, ref) => {
  const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles({
    styles,
    defaultStyles: primaryBlockDefaultStyles,
  });

  return (
    <BlockSection ref={ref} className={className} {...rest}>
      <BlockSection.Background style={backgroundStyles}>
        <BlockSection.Container>
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <div className="wb-flex wb-flex-col wb-gap-4">
              <BlockSection.NestedBlock>{image}</BlockSection.NestedBlock>
              <div className="wb-flex wb-flex-col wb-gap-3 wb-justify-between">
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3">
                  {content}
                </BlockSection.NestedBlock>
              </div>
            </div>
          </BlockSection.Content>
        </BlockSection.Container>
      </BlockSection.Background>
    </BlockSection>
  );
});

BlogListingItemBlock.displayName = "BlogListingItemBlock";
